export const isClientError = (statusCode) => statusCode.toString().slice(0, 1) === "4";
